module.exports = __webpack_public_path__ + "img/januca.68991860.jpeg";